import { IState } from '../../store';

export function banksListSelector({ banksList, mortgage }: IState) {
  if (!mortgage.bankIds) {
    return banksList;
  }
  const actualBankIds = new Set(mortgage.bankIds);

  return banksList.filter(bank => actualBankIds.has(bank.id));
}
